import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_RAPID_DATA,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("Error Response: " + error);
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      console.log("Logging out user...");
      localStorage.clear();
      window.location.href = "/auth";
    }
    return Promise.reject(error);
  }
);

export default api;
